<template>
  <main>
    <div class="py-4 pt-5 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <argon-button :to="{ name: 'Penilaian Kinerja' }" isRouteLink outline><font-awesome-icon
                  icon="fa-solid fa-chevron-left" /> Kembali</argon-button>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton type="submit">Simpan</ArgonButton>
                    <ArgonButton :to="{ name: 'Penilaian Kinerja' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <FieldsetComponent title="Informasi Umum"
                description="Lengkapi informasi umum dari master data penilaian kinerja umum, berupa Nama Penilaian Kinerja, Jabatan, serta Unit Kerja.">
                <div class="flex flex-col gap-5">
                  <form-group label="Nama Penilaian Kerja" idinput="name"
                    invalidmsg="Wajib di isi dan harus di awali dengan alphanumeric">
                    <InputForm type="text" name="name" idinput="name"
                      placeholder="Silakan tulis nama penilaian kinerja disini..." v-model="data.nama_penilaian_kinerja"
                      :isinvalid="!validateInput('name', data.nama_penilaian_kinerja)" required />
                  </form-group>

                  <!-- <form-group label="Unit Kerja" idinput="name">
                    <select-form name="unit_kerja_id" idinput="unit_kerja_id" v-model="data.unit_kerja_id" :options="unitkerja.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" />
                  </form-group> -->

                  <form-group label="Jabatan" idinput="jabatan_id">
                    <!-- <select-form name="jabatan_id" idinput="jabatan_id" v-model="data.jabatan_id" :disabled="!(this.data.unit_kerja_id != undefined && this.data.unit_kerja_id != '' && this.data.unit_kerja_id != null)" :options="jabatan.map((item) => { -->
                    <!-- <select-form name="jabatan_id" idinput="jabatan_id" v-model="data.jabatan_id" :options="jabatan.map((item) => {
                      return {
                        value: item.id,
                        text: item.name,
                      };
                    })" /> -->

                    <model-list-select
                      class="form-control"
                      style="width: 100%;"
                      v-model="data.jabatan_id"
                      :list="jabatan"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Jabatan"
                    />
                  </form-group>

                  <form-group label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="active" v-model="data.status"
                        name="status" id="status_0" autocomplete="off">
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="inactive" v-model="data.status"
                        name="status" id="status_1" autocomplete="off">
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>

              <FieldsetComponent title="Aspek Penilaian Kinerja"
                description="Masukkan data aspek penilaian kinerja yang akan dijadikan master atau aspek penilaian wajib bagi semua karyawan sesuai jabatan dan unit kerja masing-masing.">
                <form
                  @submit.prevent="addCategoryKpi()"
                >
                  <!-- v-if="insertedKpiCategory.length === 0" -->
                  <FormGroup label="Kategori Penilaian Kinerja">
                    <div class="d-flex flex-row gap-2 justify-content-between">
                      <!-- <input type="text" name="categorykpi" id="categorykpi" class="form-control" placeholder="Contoh “Kredit”"> -->
                      <input-form v-model="data.categorykpi"
                        placeholder="Tulis Kategori aspek penilaian kinerja disini...." idinput="categorykpi" />
                      <button type="submit" class="btn mb-0 undefined btn-md null null"
                        style="background-color: rgb(3, 133, 243); color: rgb(255, 255, 255);">Tambah</button>
                    </div>
                  </FormGroup>
                </form>

                <FieldsetComponent
                  v-if="insertedKpiCategory.length > 0"
                  title="Daftar Kategori KPI dan Aspek Penilaian Kinerja nih"
                  isFieldsetRow
                >
                  <div class="d-flex flex-column gap-4">
                    <div v-for="(item, index) in  insertedKpiCategory " :key="index" class="border p-2">
                      <FormGroup label="Kategori KPI">
                        <div class="d-flex flex-row gap-2">
                          <!-- <div class="form-control">{{ item?.title ?? "&nbsp;" }}</div> -->
                          <div class="flex-grow-1">
                            <input-form v-model="insertedKpiCategory[index].title"
                              placeholder="Tulis Kategori KPI"
                              required
                            />                            
                          </div>
                          <!-- <button type="button" class="btn mb-0 undefined btn-md null null"
                            style="background-color: rgb(3, 133, 243); color: rgb(255, 255, 255);"
                            @click="insertedKpiCategory.splice(index, 1)">Hapus</button> -->
                            <button type="button" @click="insertedKpiCategory.splice(index, 1)" class="btn-action btn-action--delete">Hapus</button>
                        </div>
                      </FormGroup>
                      <FormGroup label="Prespektif" idinput="prespektif" invalidmsg="Wajib di isi">
                        <select-form name="prespektif" idinput="prespektif" class="text-capitalize" :isinvalid="!validateInput('prespektif', insertedKpiCategory[index].perspektif)" v-model="insertedKpiCategory[index].perspektif" placeholder="Silakan pilih prespektif" :options="perspektif_list.map((item, index) => {
                          return {
                            value: item,
                            text: item,
                          };
                        })" />
                      </FormGroup>
                      <div v-if="item.sub.length < 1" class="border p-2 text-center px-4">
                        <h6>Tambahkan Aspek penilaian kinerja<br>{{ item?.title ?? "-" }}</h6>
                        <p>Kinerja terdiri dari nama target, jumlah target, satuan target, bobot, nilai </p>
                        <ArgonButton type="button" @click="this.currentIndexAspek = index; this.insertedAspek = []"
                          databstoggle="modal" databstarget="#exampleModal">
                          Tambah Aspek
                        </ArgonButton>
                      </div>

                      <div v-if=" item.sub.length > 0 " class="px-4">
                        <div class="table-responsive" style="text-align: left;">
                          <table class="table">
                            <thead>
                              <tr>
                                <th>Sub Aspek</th>
                                <th>Target</th>
                                <th>Satuan</th>
                                <th>Bobot</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="( item_sub, index_sub ) in  item.sub " :key=" index_sub ">
                                <td>
                                  <!-- {{
                                    aspekkpi.find((itm) => {
                                      return itm.id == item_sub.id
                                    })?.name || '-'
                                  }} -->
                                  {{ item_sub?.nama_aspek_kpi || '-' }}
                                </td>
                                <td>
                                  <span v-if="item_sub?.satuan?.toLowerCase() === 'rupiah'">
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                      }).format(item_sub?.target || '0')
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      new Intl.NumberFormat('id-ID', {
                                        minimumFractionDigits: 0,
                                      }).format(item_sub?.target || '0')
                                    }} 
                                    <span class="text-capitalize">{{ (item_sub?.satuan?.toLowerCase() === 'persen' ? '%' : item_sub?.satuan) || '-' }}</span>
                                  </span>
                                </td>
                                <!-- <td class="text-capitalize">{{ getSatuan(item_sub?.satuan) || "-" }}</td> -->
                                <td>{{ item_sub?.satuan || "-" }}</td>
                                <td>{{ item_sub?.bobot ? item_sub?.bobot +'%' : "-" }}</td>
                                <!-- <td>
                                  <ThreeDotsMenu>
                                    <button type="button" @click.prevent=" insertedKpiCategory[index].sub.splice(index_sub, 1) "
                                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link"
                                      data-toggle="tooltip" data-original-title="Delete user">Hapus</button>
                                  </ThreeDotsMenu>
                                </td> -->
                                <td>
                                  <div class="d-flex gap-1 justify-content-end">
                                    <button type="button" class="btn-action btn-action--icon-small btn-action--secondary" data-bs-toggle="modal" data-bs-target="#editModal" @click="editAspek(item_sub, index, index_sub)">
                                      <font-awesome-icon icon="fa-solid fa-pen" />
                                    </button>
                                    <button type="button" @click="insertedKpiCategory[index].sub.splice(index_sub, 1)" class="btn-action btn-action--icon-small btn-action--delete">
                                      <font-awesome-icon icon="fa-solid fa-trash" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </FieldsetComponent>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>

    <!-- modal add -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <form @submit.prevent=" saveModal() ">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Sub Menu</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column">
                <form @submit.prevent="addAspek()">
                  <GridRow :gap="-1">
                    <GridCol :md="4">
                      <FormGroup label="Cari Aspek" idinput="titleaspek" invalidmsg="Aspek sudah ada">
                        <!-- <select-form name="title" id="titleaspek" v-model="selectedAspek.aspek_id" :isinvalid="invalidSelectedAspekId" placeholder="Cari aspek disini" :options="aspekkpi.map((item) => {
                          return {
                            value: item.id,
                            text: item.name,
                          };
                        })" /> -->
                        <model-list-select
                          class="form-control"
                          style="width: 100%;"
                          v-model="selectedAspek.aspek_id"
                          :list="aspekkpi"
                          option-value="id"
                          option-text="name"
                          placeholder="Cari aspek disini"
                        />
                        <span v-if="invalidSelectedAspekId" class="text-danger text-sm">Aspek sudah ada</span>
                      </FormGroup>
                    </GridCol>
                    <GridCol :md="2">
                      <FormGroup label="Target" idinput="targetaspek">
                        <input-form type="number" name="target" idinput="targetaspek" placeholder="Tulis jumlah target"
                          v-model=" selectedAspek.target " />
                      </FormGroup>
                    </GridCol>
                    <GridCol :md="2">
                      <FormGroup label="Satuan Target" idinput="satuanaspek">
                        <!-- <select-form name="satuanaspek" id="satuanaspek" v-model="selectedAspek.satuan" :options="satuan_target.map((item) => { -->
                        <select-form name="satuanaspek" id="satuanaspek" v-model="selectedAspek.satuan" :options="list_satuan_target.map((item) => {
                          return {
                            value: item?.nama_satuan,
                            text: item?.nama_satuan,
                          };
                        })" />
                      </FormGroup>
                    </GridCol>
                    <GridCol :md="2">
                      <FormGroup label="Bobot" idinput="bobotaspek">
                        <input-form type="number" name="bobotaspek" idinput="bobotaspek" placeholder="Tulis jumlah target"  step="0.01" min="0"
                          v-model=" selectedAspek.bobot " />
                      </FormGroup>
                    </GridCol>
                    <GridCol style="text-align: right;" :md="2">
                      <br>
                      <ArgonButton :disabled=" this.invalidSelectedAspekId " type="submit">Simpan</ArgonButton>
                    </GridCol>
                  </GridRow>
                </form>

                <hr>

                <FieldsetComponent title="Daftar Sub Aspek Penilaian Kinerja" isFieldsetRow>
                  <div class="d-flex flex-column gap-2">
                    <GridRow v-for="( item, index ) in  insertedAspek " :key=" index " :gap="-1">
                      <GridCol :md="4">
                        <FormGroup label="Nama Aspek" idinput="titleaspek">
                          <select-form name="title" :id="'titleaspek-' + index" v-model="item.aspek_id" disabled :options="aspekkpi.map((item) => {
                            return {
                              value: item.id,
                              text: item.name,
                            };
                          })" />
                        </FormGroup>
                      </GridCol>
                      <GridCol :md="2">
                        <FormGroup label="Target" idinput="targetaspek">
                          <input-form type="number" name="target" idinput="targetaspek" placeholder="Tulis jumlah target"
                            v-model=" item.target" min="0" />
                        </FormGroup>
                      </GridCol>
                      <GridCol :md="2">
                        <FormGroup label="Satuan Target" idinput="satuanaspek">
                            <!-- <select-form name="satuanaspek" id="satuanaspek" v-model="item.satuan" :options="satuan_target.map((item) => { -->
                            <select-form name="satuanaspek" :id="'satuanaspek-' + index" v-model="item.satuan" :options="list_satuan_target.map((item) => {
                            return {
                              value: item?.nama_satuan,
                              text: item?.nama_satuan,
                            };
                          })" />
                        </FormGroup>
                      </GridCol>
                      <GridCol :md="2">
                        <FormGroup label="Bobot" idinput="bobotaspek">
                          <input-form type="number" name="bobotaspek" idinput="bobotaspek"
                            placeholder="Tulis jumlah target" v-model=" item.bobot " />
                        </FormGroup>
                      </GridCol>
                      <GridCol style="text-align: right;" :md="2">
                        <br>
                        <!-- <ArgonButton @click="deleteInsertedAspek(index)" color="danger" type="button">
                          Hapus {{ index }}
                        </ArgonButton> -->
                        <button class="btn btn-danger" @click="deleteInsertedAspek(index)" type="button">Hapus</button>
                      </GridCol>
                    </GridRow>

                  </div>
                </FieldsetComponent>
              </div>
            </div>
            <div class="modal-footer">
              <ArgonButton type="button" color="secondary" databsdismiss="modal">Batalkan</ArgonButton>
              <ArgonButton @click="saveModal()" databsdismiss="modal" >Simpan</ArgonButton>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- modal edit -->
    <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <form @submit.prevent="updateEditAspek()">
            <div class="modal-header">
              <h5 class="modal-title" id="editModalLabel">Edit Sub Aspek</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-column">
                <GridRow :gap="-1">
                  <GridCol :md="6">
                    <FormGroup label="Cari Aspek" idinput="titleaspek" invalidmsg="Aspek sudah ada">
                      <!-- <select-form name="title" id="titleaspekedit" v-model="edit_aspek_data.aspek_id" :isinvalid="invalidEditAspekId" placeholder="Cari aspek disini" :options="aspekkpi.map((item) => {
                        return {
                          value: item.id,
                          text: item.name,
                        };
                      })" /> -->
                      <model-list-select
                        class="form-control"
                        style="width: 100%;"
                        v-model="edit_aspek_data.aspek_id"
                        :list="aspekkpi"
                        option-value="id"
                        option-text="name"
                        placeholder="Cari aspek disini"
                      />
                      <span v-if="invalidEditAspekId" class="text-danger text-sm">Aspek sudah ada</span>
                    </FormGroup>
                  </GridCol>
                  <GridCol :md="2">
                    <FormGroup label="Target" idinput="targetaspek">
                      <input-form type="number" name="target" idinput="targetaspek" placeholder="Tulis jumlah target"
                        v-model=" edit_aspek_data.target " />
                    </FormGroup>
                  </GridCol>
                  <GridCol :md="2">
                    <FormGroup label="Satuan Target" idinput="satuanaspek">
                      <!-- <select-form name="satuanaspek" id="satuanaspek" v-model="edit_aspek_data.satuan" :options="satuan_target.map((item) => { -->
                      <select-form name="satuanaspek" id="satuanaspek-edit" v-model="edit_aspek_data.satuan" :options="list_satuan_target.map((item) => {
                        return {
                          value: item?.nama_satuan,
                          text: item?.nama_satuan,
                        };
                      })" />
                    </FormGroup>
                  </GridCol>
                  <GridCol :md="2">
                    <FormGroup label="Bobot" idinput="bobotaspek">
                      <input-form type="number" name="bobotaspek" idinput="bobotaspek" placeholder="Tulis jumlah target"  step="0.01" min="0"
                        v-model=" edit_aspek_data.bobot " />
                    </FormGroup>
                  </GridCol>
                </GridRow>
              </div>
            </div>
            <div class="modal-footer">
              <ArgonButton type="button" color="secondary" databsdismiss="modal">Batalkan</ArgonButton>
              <ArgonButton @click="updateEditAspek()" databsdismiss="modal" >Simpan</ArgonButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue"
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
import MetaSection from "@/components/MetaSection.vue";
import InputForm from '@/components/InputForm.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

import AspekKinerjaApi from "@/repository/api/AspekKinerjaApi";
// import ListView from '@/components/ListView.vue';
// import ThreeDotsMenu from "@/components/ThreeDotsMenu.vue";
import KpiApi from "@/repository/api/KpiApi";
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import JabatanApi from "@/repository/api/JabatanApi";
import SelectForm from '@/components/SelectForm.vue';
import SatuanTargetApi from '@/repository/api/SatuanTargetApi';

export default {
  // name: "profile",
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    ArgonButton,
    GridRow,
    GridCol,
    MetaSection,
    InputForm,
    // ListView,
    // ThreeDotsMenu,
    SelectForm,
    ModelListSelect,
  },
  data() {
    return {
      kpiCategory: [],
      optionKpiCategory: [],
      insertedKpiCategory: [],
      operator: {
        "<": "Kurang dari",
        "<=": "Kurang dari samadengan",
        ">": "Lebih dari",
        ">=": "Lebih dari samadengan",
        "=": "samadengan",
      },
      showMenu: false,
      data: {
        // title: '',
        nama_penilaian_kinerja: '',
        jabatan_id: "",
        // unit_kerja_id: "",
        status: "",

        jabatan: {},
        aspekpenilaian: [],
      },
      unitkerja: [],
      jabatan: [],
      myValue: '',
      aspekkpi: [],
      paramsAspek: {
        keyword: "",
      },
      selectedAspek: {
        // id: null,
        aspek_id: null,
        // title: null,
        nama_aspek_kpi: null,
        target: null,
        satuan: null,
        bobot: null,
      },
      insertedAspek: [],
      currentIndexAspek: null,
      invalidSelectedAspekId: false,
      submitable: true,
      // ----------------------------------------------------------------------------
      // perspektif: '',
      perspektif_list: [
        'finance',
        'customer',
        'internal business process',
        'learn & growth',
      ],
      edit_aspek_data: {
        aspek_id: '',
        bobot: 1,
        nama_aspek_kpi: '',
        satuan: '',
        target: 0,
      },
      invalidEditAspekId: false,
      index_edit_category: null,
      index_edit_sub_category: null,
      list_satuan_target: [],
      // satuan_target: [
      //   {
      //     value: 'rupiah',
      //     label: 'Rupiah'        
      //   },
      //   {
      //     value: 'persen',
      //     label: 'Persen/Hari/Skala Nilai'        
      //   },
      //   {
      //     value: 'pcs',
      //     label: 'Pcs'        
      //   }
      // ],
    };
  },
  watch: {
    // 'selectedAspek.id': {
    'selectedAspek.aspek_id': {
      handler: async function (newVal) {
        if (this.insertedAspek.map((item) => { return item.aspek_id }).includes(newVal)) {
          this.invalidSelectedAspekId = true;
        }
        else {
          this.invalidSelectedAspekId = false;
        }
        // this.selectedAspek['title'] = null;
        this.selectedAspek['nama_aspek_kpi'] = null;
        this.selectedAspek['target'] = null;
        this.selectedAspek['satuan'] = null;
        this.selectedAspek['bobot'] = null;
      },
      deep: true,
    },
    'edit_aspek_data.aspek_id': {
      handler: async function (newVal) {
        if (this.insertedKpiCategory?.[this.index_edit_category]) {
          if (this.insertedKpiCategory[this.index_edit_category].sub.map((item) => { return item.aspek_id }).includes(newVal) && this.insertedKpiCategory[this.index_edit_category].sub[this.index_edit_sub_category].aspek_id !== newVal) {
            this.invalidEditAspekId = true;
            this.edit_aspek_data.nama_aspek_kpi = '';
          }
          else {
            this.invalidEditAspekId = false;
            this.edit_aspek_data.nama_aspek_kpi = this.aspekkpi.filter((item) => item.id === newVal)?.[0]?.name;
          }
        }
      },
      deep: true,
    },
    // 'data.unit_kerja_id': {
    //   handler: async function () {
    //     // this.data.jabatan_id = null;
    //     await this.getJabatan()
    //   },
    //   deep: true,
    // },
  },
  methods: {
    validateInput(field, data) {
      let test = Boolean
      switch (field) {
        case "name":
          test = /^([\w!@#$%^&*(),.?":{}|<>-](\s?))+$/.test(data)
          break;
        case "prespektif":
          test = /^.+$/.test(data)
          break;
        default:
          break;
      }
      this.submitable = test
      return test;
    },
    showKategori() {
      return this.insertedKpiCategory.length > 0 || this.data.aspekpenilaian.length > 0;
    },
    saveModal() {
      // this.insertedKpiCategory[this.currentIndexAspek]['sub'] = JSON.parse(JSON.stringify(this.insertedAspek));

      // this.insertedAspek.nama_aspek_kpi = this.aspekkpi.find((itm) => { return itm.id == this.insertedAspek.id })?.name || '';
      // console.log(this.aspekkpi.find((itm) => { return itm.id == this.insertedAspek.id })?.name)

      if (!this.insertedAspek) {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: "Sub aspek penilaian belum ditambahkan",
        });

        return;
      }

      this.insertedAspek.forEach((item, index) => {
        this.insertedAspek[index].nama_aspek_kpi = this.aspekkpi.find((itm) => { return itm.id == item.aspek_id })?.name || '';
      });
      if (this.$route.params?.id) {
        this.insertedAspek.sub_kpi_id = '';
      }

      this.insertedKpiCategory[this.currentIndexAspek]['sub'] = this.insertedAspek;
    },
    addAspek() {
      // if (this.selectedAspek.id != null && this.selectedAspek.target != null && this.selectedAspek.satuan != null && this.selectedAspek.bobot != null) {
      if (this.selectedAspek.aspek_id != null && this.selectedAspek.target != null && this.selectedAspek.satuan != null && this.selectedAspek.bobot != null) {
        this.insertedAspek.push(JSON.parse(JSON.stringify(this.selectedAspek)));
        this.selectedAspek = {
          // id: null,
          aspek_id: null,
          // title: null,
          nama_aspek_kpi: null,
          target: null,
          satuan: null,
          bobot: null,
        };
      }
      else {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: "Pencarian aspek belum di isi dengan benar"
        });
      }
    },
    deleteInsertedAspek(index_aspek) {
      this.insertedAspek.splice(index_aspek, 1);
    },
    editAspek(data, index, index_sub) {
      this.index_edit_category = index
      this.index_edit_sub_category = index_sub
      this.edit_aspek_data = JSON.parse(JSON.stringify(data))
    },
    updateEditAspek() {
      if (this.invalidEditAspekId) {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: "Sub aspek penilaian sudah terdaftar!",
        });
        return;
      }
      this.insertedKpiCategory[this.index_edit_category].sub[this.index_edit_sub_category] = JSON.parse(JSON.stringify(this.edit_aspek_data));
      setTimeout(() => {
        this.edit_aspek_data = {
          aspek_id: '',
          bobot: 1,
          nama_aspek_kpi: '',
          satuan: '',
          target: 0,
        }
      }, 50);
    },
    async getSatuanTarget() {
      await SatuanTargetApi.get()
        .then((response) => {
          // console.log(response?.data);
          this.list_satuan_target = response?.data || [];
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getAspekKpi() {
      this.$store.state.loading = true;
      // await AspekKinerjaApi.get(
      await AspekKinerjaApi.getbyparam({
        master: 1,
        page: 'all',
      })
        .then((response) => {
          this.aspekkpi = response.data;
        }).catch(() => {
          this.aspekkpi = [];
        });
      this.$store.state.loading = false;
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.unitkerja = response.data;
        }).catch(() => {
          this.params.jabatan_id = null;
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({
        // unitkerja_id: this.data.unit_kerja_id,
        page: 'all',
      })
        .then((response) => {
          this.jabatan = response.data;
        }).catch(() => {
          this.jabatan = [];
        })
      this.$store.state.loading = false;
    },
    async addCategoryKpi() {
      if (this.data.categorykpi != "" && this.data.categorykpi != null && this.data.categorykpi != undefined) {
        if (this.insertedKpiCategory.map((item) => { return item?.title }).includes(this.data.categorykpi)) {
          this.$swal({
            icon: "error",
            title: "Kategori sudah ada"
          })
        }
        else {
          this.insertedKpiCategory.push({
            // title: this.data.categorykpi,
            // nama_penilaian_kinerja: this.data.categorykpi,
            title: this.data.categorykpi,
            perspektif: '',
            code: '',
            description: '',
            type: 'master',
            sub: [],
          })
        }
        this.data.categorykpi = null;
      }
    },
    async getKpiCategory() {
      this.$store.state.loading = true;
      await KpiApi.getByParamsNew({view_option: 1}).then((response) => {
        this.kpiCategory = response.data;
      }).catch(() => {
        this.kpiCategory = [];
      });
      await this.getOptionKpiCategory();
      this.$store.state.loading = false;
    },
    async getOptionKpiCategory() {
      this.optionKpiCategory = this.kpiCategory.map((item) => {
        return {
          id: item.id,
          text: item.title,
        };
      })
      // console.log(this.optionKpiCategory)
    },
    async submit() {
      const periksa = await this.$swal({
        icon: 'warning',
        title: 'Periksa Kembali',
        text: 'Pastikan data penilaian kinerja yang Anda masukkan sudah sesuai. Silakan periksa kembali sebelum klik tombol Simpan karena data yang sudah disimpan tidak akan bisa diubah kembali',
        showCancelButton: true,
        cancelButtonText: "Sudah",
        confirmButtonText: "PERIKSA"
      }).then((result) => {
        return result.dismiss == 'cancel';
      });

      if (!periksa) return;

      if (this.insertedKpiCategory?.length === 0 || this.insertedKpiCategory?.[0]?.sub?.length === 0) {
        this.$swal({ icon: "error", title: "Aspek penilaian kinerja perlu diisi!" });
        return;
      }

      if (!this.submitable) {
        this.$swal({ icon: "error", title: "Form Belum Lengkap" });
        return;
      }

      this.$store.state.loading = true;
      let data = JSON.parse(JSON.stringify(this.data));

      delete data.aspekpenilaian;
      delete data.categorykpi;
      delete data.jabatan;

      console.log(this.insertedKpiCategory)

      data.kpi = JSON.parse(JSON.stringify(this.insertedKpiCategory))

      data.kpi = data.kpi.map((item) => {
        item.category = item.sub;
        delete item.sub;
        return item;
      });

      data.kpi = JSON.stringify(data.kpi);

      console.log('form submit')
      console.log(data)

      try {
        if (this.$route.params.id) {
          data.id = this.$route.params.id;
          await KpiApi.updateNew(data).then(() => {
            this.$swal({ icon: "success", title: "Berhasil" }).then(() => {
              this.$router.push({ name: "Penilaian Kinerja" });
            });
          }).catch((error) => {
            this.$swal({ icon: "error", title: error?.response?.data?.message ?? "Internal Server Error" });
          });
        } else {
          await this.submitNew(data);
        }
      } finally {
        this.$store.state.loading = false;
      }
    },
    async submitNew(data) {
      if (this.insertedKpiCategory.length < 1) {
        this.$swal({ icon: "error", title: "Form Belum Lengkap" });
        return;
      }
      const hasEmptySub = this.insertedKpiCategory.some(item => item.sub.length === 0);
      if (hasEmptySub) {
        this.$swal({ icon: "error", title: "Form Belum Lengkap" });
        return;
      }
      await KpiApi.createNew(data).then(() => {
        this.$swal({ icon: "success", title: "Berhasil" }).then(() => {
          this.$router.push({ name: "Penilaian Kinerja" });
        });
      }).catch((error) => {
        this.$swal({ icon: "error", title: error.response.data.message });
      });
    },
    async getData() {
      this.$store.state.loading = true;
      // await KpiApi.getNew(this.$route.params.id).then((response) => {
      await KpiApi.getByParamsNew({
        id: this.$route.params.id,
      })
        .then((response) => {
          console.log(response?.data)
          const data = response?.data?.[0];

          if (data) {
            // this.data.title = data?.title || '';
            this.data.nama_penilaian_kinerja = data?.title || '';
            this.data.jabatan_id = data?.jabatan_id || '';
            // this.data.unit_kerja_id = data?.unitkerja_id || '';
            this.data.status = data?.status || '';

            this.insertedKpiCategory = data?.kpi?.map((item) => {
              return {
                title: item.title,
                perspektif: item.perspektif,
                type: item?.type || 'master',
                sub: item?.child?.map((item_child) => {
                  return {
                    aspek_id: item_child?.aspek_id,
                    nama_aspek_kpi: item_child?.title,
                    target: item_child?.target,
                    satuan: item_child?.satuan,
                    bobot: item_child?.bobot,
                  };
                }) || [],
              };
            }) || [];
          }
        })
        .catch((error) => {
          console.log(error)
          // this.$swal({
          //   icon: "error",
          //   title: error?.response?.data?.message,
          // }).then(() => {
          //   // this.$router.push({ name: "Penilaian Kinerja" });
          // });
        })
      this.$store.state.loading = false;
    },
    // getSatuan(satuan) {
    //   let result = null
    //   try {
    //     result = this.satuan_target.find(({ value }) => value === satuan);
    //     result = result.label
    //   } catch (error) {
    //     result = satuan
    //   }
    //   return result
    // }
  },
  async mounted() {
    await this.getKpiCategory();
    // await this.getUnitKerja();
    await this.getJabatan();
    await this.getAspekKpi();
    await this.getSatuanTarget();
    if (this.$route.params.id) {
      await this.getData();
    }
    // await this.getEmployee();
  },
};
</script>
